<div
  [aut-id]="autId"
  class="cross-btn {{ colorClassName }}"
  [tabindex]="isFocusable && !disabled ? 0 : -1"
  role="button"
  aria-label="Remove"
  [attr.aria-disabled]="disabled || null"
  (click)="clicked($event)"
  (keydown.enter)="clicked($event)"
  (keydown.space)="clicked($event); $event.preventDefault()"
  (keydown.spacebar)="clicked($event); $event.preventDefault()"
>
  @if (useText) { @if (!pending) {
  <cross
    class="cross-comp"
    [colorClassName]="colorClassName"
    [changeOnHover]="changeOnHover"
    [noCrossMargin]="noCrossMargin"
    [crossSize]="size"
    iconTitle="Remove"
  >
  </cross>
  }
  <span class="button-text">
    <ng-content></ng-content>
  </span>

  } @if (!useText) {

  <span class="button-text">
    <a360-icon [autId]="autId" icon="trash-bin" [color]="colorClassName" [attr.width]="size" height="26px"></a360-icon>
  </span>

  }
</div>
